import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import FaDownload from 'react-icons/lib/fa/download';
import {makeRequest,  dispatchAction, displayMessage}  from 'actions';
import momentTimeZone from 'moment-timezone'
import moment from 'moment'
import config from '../../../config';
import Select   from 'react-select'
import {Link} from 'react-router';
import {FETCH_ALL_SELLERS_LIST,} from "actions/actionTypes";

import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';

import queryString from 'query-string'

import formatNumbers  from 'util/formatNumbers';
import json2csv   from 'json2csv'
import { validateEmail, linkFormatter, convertToHoursAndMinutes, isIsoDate,  prepareSelectOptionsList } from 'util/Utils';
import KPIReportsTable  from "./KPIReportsTable";
import DailyKPIReportTable  from "./DailyKPIReportTable";
import Datetime from 'react-datetime'
import _ from 'lodash';
var async = require('async');

const dropOffsCreated = {
        label: 'Drop-offs created', 
        value: 'DropoffCreated',
        queryParams: {
            fromCreateTime: 'from_date',
            toCreateTime: 'to_date',
            ServiceTypes: ['Dropoff'],
        },
        endpoint: '/pickups', format: (data) => {
        return _.get(data, 'total')
    }
}

const pickUpsCreated =  {
    label: 'Pick-ups created', 
    value: 'PickupCreated',
    queryParams: {
        fromCreateTime: 'from_date',
        toCreateTime: 'to_date',
        ServiceTypes: ['Pickup'],
    },
    endpoint: '/pickups', format: (data) => {
        return _.get(data, 'total')
    }
}

const dropOffSchedule = {
    label: 'Drop-offs scheduled', 
    value: 'DropoffScheduled',
    queryParams: {
        from: 'from_date',
        to: 'to_date',
        ServiceTypes: ['Dropoff'],
    },
    endpoint: '/pickups', format: (data) => {
        return _.get(data, 'total')
    }
}

const pickUpsSchedule = {
    label: 'Pick-ups scheduled', 
    value: 'PickupScheduled',
    queryParams: {
        from: 'from_date',
        to: 'to_date',
        ServiceTypes: ['Pickup'],
    },
    endpoint: '/pickups', format: (data) => {
        return _.get(data, 'total')
    }
}

const dropOffReceived =  {
    label: 'Drop-offs received',
    value: 'DropoffReceived',
    queryParams: {
        ServiceTypes: ['Dropoff'],
        customQueriesData: {
            '#date_1#': 'from_date',
            '#date_2#': 'to_date'
        },
        customQueries: JSON.stringify([
            {
                '$match': {
                    ChangeLog: {
                        $elemMatch: {
                            $and: [
                                {"FieldChanged": "Status"},
                                {"To": "Received"},
                                {'createdAt': {$gte: '#date_1#'}},
                                {'createdAt': {$lte: '#date_2#'}}
                            ]
                        }
                    }
                }
            },
        ]),

    },
    endpoint: '/pickups', format: (data) => {
        return _.get(data, 'total')
    }
}

const  pickupsReceived = {
    label: 'Pickups received', 
    value: 'PickupReceived',
    queryParams: {
        ServiceTypes: ['Pickup'],
        customQueriesData: {
            '#date_1#': 'from_date',
            '#date_2#': 'to_date'
        },
        customQueries: JSON.stringify([
            {
                '$match': {
                    ChangeLog: {
                        $elemMatch: {
                            $and: [
                                {"FieldChanged": "Status"},
                                {"To": "Received"},
                                {'createdAt': {$gte: '#date_1#'}},
                                {'createdAt': {$lte: '#date_2#'}}
                            ]
                        }
                    }
                }
            },
        ]),
    },
    endpoint: '/pickups', format: (data) => {
        return _.get(data, 'total')
    }
}

const dropOffsCancelled =  {
    label: 'Drop-offs cancelled', 
    value: 'DropoffCancelled',
    queryParams: {
        action:'DropoffCancelled',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    },
    "endpoint": "/run-process",
    'type':'post',
    format: (data, params={}) => {
         data.ServicesTotalNumber =_.size(data.DropoffCancelled.ServiceRecords)
         if (data.ServicesTotalNumber > 0 ) {


            if (  data.ServicesTotalNumber  <1000) {
                var servicesLink = linkFormatter({}, data, {
                    labelPath: ['ServicesTotalNumber'],
                    path: 'getObject',
                    formatPathValue: (item) => {
                        var recordIDs = _.map(item.DropoffCancelled.ServiceRecords, itemID => {
                            return encodeURIComponent(itemID)
                        })
                        return 'recordIDs=' +recordIDs.join(',')
                    },
                    placeholder: '[queryParams]',
                    template: config.getEnvironment().serverBaseURL + '/admin/services?[queryParams]',
                })
            }else{
                var servicesLink =data.ServicesTotalNumber
            }


            if (_.includes(['sendemail','download'],params.type) ){
                return   _.get(data, 'ServicesTotalNumber', 0)
            } else {
                return <div>

                    { _.get(data, 'ServicesTotalNumber', 0) ?
                        servicesLink : <span>{_.get(data, 'ServicesTotalNumber', 0)}</span>
                    }

                </div>
            }
        } else {
            return 'n/a';
        }
     
    }
}

const pickupsCancelled = {
    label: 'Pick-ups cancelled', 
    value: 'PickupCancelled',
    queryParams: {
        action:'PickupCancelled',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    },
    "endpoint": "/run-process",
    'type':'post',
    format: (data, params={}) => {
        data.ServicesTotalNumber =_.size(data.PickupCancelled.ServiceRecords)
        if (data.ServicesTotalNumber > 0 ) {


            if (  data.ServicesTotalNumber  <1000) {
                var servicesLink = linkFormatter({}, data, {
                    labelPath: ['ServicesTotalNumber'],
                    path: 'getObject',
                    formatPathValue: (item) => {
                        var recordIDs = _.map(item.PickupCancelled.ServiceRecords, itemID => {
                            return encodeURIComponent(itemID)
                        })
                        return 'recordIDs=' +recordIDs.join(',')
                    },
                    placeholder: '[queryParams]',
                    template: config.getEnvironment().serverBaseURL + '/admin/services?[queryParams]',
                })
            }else{
                var servicesLink =data.ServicesTotalNumber
            }


            if (_.includes(['sendemail','download'],params.type) ){
                return   _.get(data, 'ServicesTotalNumber', 0)
            } else {
                return <div>

                    { _.get(data, 'ServicesTotalNumber', 0) ?
                        servicesLink : <span>{_.get(data, 'ServicesTotalNumber', 0)}</span>
                    }

                </div>
            }
        } else {
            return 'n/a';
        }
    }
}

const averageTimePerPickupAndGBGOrderDelivery =  {
    label: 'Average time per pickup and GBG order delivery', 
    value: 'AverageTimePerPickupAndDelivery',
    queryParams: {
        action: 'AverageTimePerPickupAndDelivery',
        fromDate: 'from_date',
        toDate: 'to_date',
    }, type: 'post', endpoint: '/process-action', format: (data,params={}) => {
          if (_.get(data, 'TotalWorkingTimeDuration', 0) > 0 && _.get(data, 'ServicesAndDeliveriesTotalNumber', 0)  >0) {
            var totalDuration = convertToHoursAndMinutes(moment.duration(data.TotalWorkingTimeDuration), {format: 'hours_and_minutes'})
            var duration = moment.duration(data.TotalWorkingTimeDuration / data.ServicesAndDeliveriesTotalNumber)

            var averageTime =data.AverageTimePerPickupAndDelivery =convertToHoursAndMinutes(duration, {format: 'hours_minutes_seconds'})
            if (_.size(_.get(data, 'WorkingTimeRecords', []))  <1000) {
                data.totalDuration =totalDuration
                averageTime = linkFormatter({}, data, {
                    labelPath: ['AverageTimePerPickupAndDelivery'],
                    path: 'getObject',
                    formatPathValue: (item) => {
                        var recordIDs = _.map(item.WorkingTimeRecords, itemID => {
                            return encodeURIComponent(itemID)
                        })
                        return 'recordIDs=' +recordIDs.join(',')
                    },
                    placeholder: '[queryParams]',
                    template: config.getEnvironment().serverBaseURL + '/admin/time-tracking?[queryParams]',
                })
            }

            if ( _.get(data, 'ServicesTotalNumber', 0)  <1000) {
                var servicesCreatedLink = linkFormatter({}, data, {
                    labelPath: ['ServicesTotalNumber'],
                    path: 'getObject',
                    formatPathValue: (item) => {
                        var recordIDs = _.map(item.ServicesCreated, itemID => {
                            return encodeURIComponent(itemID)
                        })
                        return 'recordIDs=' +recordIDs.join(',')
                    },
                    placeholder: '[queryParams]',
                    template: config.getEnvironment().serverBaseURL + '/admin/services?[queryParams]',
                })
            }else{
                var servicesCreatedLink =data.ServicesTotalNumber
            }
            if ( _.get(data, 'DeliveriesTotalNumber', 0)  <1000) {
                var deliveriesFulfilledLInk= linkFormatter({}, data, {
                    labelPath: ['DeliveriesTotalNumber'],
                    path: 'getObject',
                    formatPathValue: (item) => {
                        var recordIDs = _.map(item.DeliveriesFulfilled, itemID => {
                            return encodeURIComponent(itemID)
                        })
                        return 'recordIDs=' +recordIDs.join(',')
                    },
                    placeholder: '[queryParams]',
                    template: config.getEnvironment().serverBaseURL + '/admin/payout-registry?[queryParams]',
                })
            }else{
                var deliveriesFulfilledLInk =data.DeliveriesTotalNumber
            }
            if (_.includes(['sendemail','download'],params.type) ){
                return averageTime +' ( '+_.get(data, 'TotalProductsFinalized', 0) + ')'
            } else {
                return <div>
                <span>{ _.size(_.get(data, 'WorkingTimeRecords', [])) ?
                    averageTime : <span>{averageTime}</span>
                }</span>

                    { _.get(data, 'ServicesAndDeliveriesTotalNumber', 0)&&
                    <span>{_.get(data, 'ServicesAndDeliveriesTotalNumber', 0)}</span>
                    }
                    <span> ( </span>
                    { _.get(data, 'ServicesTotalNumber', 0) ?
                        servicesCreatedLink : <span>{_.get(data, 'ServicesTotalNumber', 0)}</span>
                    }
                    <span> / </span>
                    { _.get(data, 'DeliveriesTotalNumber', 0) ?
                        deliveriesFulfilledLInk : <span>{_.get(data, 'DeliveriesTotalNumber', 0)}</span>
                    }
                    <span> )</span>
                </div>
            }
        } else {
            return 'n/a';
        }
    }
}


const deliveryItemsFulfilled = {
    label: 'Delivery items fulfilled', 
    value: 'DeliveryItemsFulfilled',
    queryParams: {
        action:'DeliveryItemsFulfilled',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    },
    "endpoint": "/run-process",
    'type':'post',
    format: (data, params={}) => {

        data.ItemsFulfilledNumber =_.size(data.DeliveryItemsFulfilled.ItemsFulfilled)


        if ( data.ItemsFulfilledNumber>0&& data.ItemsFulfilledNumber <1000) {
            var itemsFulfilledLink = linkFormatter({}, data, {
                labelPath: ['ItemsFulfilledNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.DeliveryItemsFulfilled.ItemsFulfilled, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/payout-registry?[queryParams]',
            })
        }else{
            var itemsFulfilledLink =data.ItemsFulfilledNumber
        }

        if (_.includes(['sendemail','download'],params.type) ){
            return  ' ( '+data.ItemsFulfilledNumber + ' / ' +data.DeliveryItemsFulfilled.TotalOrders + ' )'
        } else {
            return <div id='delivery-items-fulfilled'>
                {  <span>   {data.ItemsFulfilledNumber > 0 ?
                  itemsFulfilledLink : data.ItemsFulfilledNumber}</span> }


                {  <span> ( {data.DeliveryItemsFulfilled.TotalOrders} orders )</span> }

            </div>
        }

    }
}

const shippingItemsFulfilled = {
    label: 'Shipping items fulfilled', 
    value: 'ShippingItemsFulfilled',
    queryParams: {
        action:'ShippingItemsFulfilled',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    },
    "endpoint": "/run-process",
    'type':'post',
    format: (data, params={}) => {

        data.ItemsFulfilledNumber =_.size(data.ShippingItemsFulfilled.ItemsFulfilled)


        if ( data.ItemsFulfilledNumber>0&& data.ItemsFulfilledNumber <1000) {
            var itemsFulfilledLink = linkFormatter({}, data, {
                labelPath: ['ItemsFulfilledNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.ShippingItemsFulfilled.ItemsFulfilled, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/payout-registry?[queryParams]',
            })
        }else{
            var itemsFulfilledLink =data.ItemsFulfilledNumber
        }

        if (_.includes(['sendemail','download'],params.type) ){
            return  ' ( '+data.ItemsFulfilledNumber + ' / ' +data.ShippingItemsFulfilled.TotalOrders + ' )'
        } else {
            return <div id='shipping-items-fulfilled'>
                {  <span>   {data.ItemsFulfilledNumber > 0 ?
                  itemsFulfilledLink : data.ItemsFulfilledNumber}</span> }

                {  <span> ( {data.ShippingItemsFulfilled.TotalOrders} orders )</span> }

            </div>
        }

    }

}


const curbsidePickupFulfilled = {
    label: 'Curbside pickup fulfilled', 
    value: 'CurbsideItemsFulfilled',
    queryParams: {
        action:'CurbsideItemsFulfilled',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    },
    "endpoint": "/run-process",
    'type':'post',
    format: (data, params={}) => {
        data.ItemsFulfilledNumber =_.size(data.CurbsideItemsFulfilled.ItemsFulfilled)


        if ( data.ItemsFulfilledNumber>0&& data.ItemsFulfilledNumber <1000) {
            var itemsFulfilledLink = linkFormatter({}, data, {
                labelPath: ['ItemsFulfilledNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.CurbsideItemsFulfilled.ItemsFulfilled, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/payout-registry?[queryParams]',
            })
        }else{
            var itemsFulfilledLink =data.ItemsFulfilledNumber
        }

        if (_.includes(['sendemail','download'],params.type) ){
            return  ' ( '+data.ItemsFulfilledNumber + ' / ' +data.CurbsideItemsFulfilled.TotalOrders + ' )'
        } else {
            return <div id='curbside-pickup-items-fulfilled'>
                {  <span>   {data.ItemsFulfilledNumber > 0 ?
                  itemsFulfilledLink : data.ItemsFulfilledNumber}</span> }

                {  <span> ( {data.CurbsideItemsFulfilled.TotalOrders} orders )</span> }

            </div>
        }

    }
}

const sellerProductsCreated = {
    label: 'Seller products created', 
    value: 'SellerProductsCreated',
    queryParams: {
         action:'SellerProductsCreated',
         waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    },
    "endpoint": "/run-process",
    'type':'post',
    format: (data, params={}) => {

        data.ProductsCreatedNumber =_.size(data.SellerProductsCreated.ProductsCreated)
        data.ProductsPlusOneNumber =_.size(data.SellerProductsCreated.ProductsPlusOne)

        if ( data.ProductsCreatedNumber>0&& data.ProductsCreatedNumber <1000) {
            var productsCreatedLink = linkFormatter({}, data, {
                labelPath: ['ProductsCreatedNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.SellerProductsCreated.ProductsCreated, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }else{
            var productsCreatedLink =data.ProductsCreatedNumber
        }
        if (  data.ProductsPlusOneNumber>0&& data.ProductsPlusOneNumber <1000) {
            var productsPlusOneLink = linkFormatter({}, data, {
                labelPath: ['ProductsPlusOneNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.SellerProductsCreated.ProductsPlusOne, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }else{
            var productsPlusOneLink =data.ProductsPlusOneNumber
        }
        if (_.includes(['sendemail','download'],params.type) ){
            return (data.ProductsCreatedNumber + data.ProductsPlusOneNumber) +' ( '+data.ProductsCreatedNumber + ' / ' +data.ProductsPlusOneNumber + ' )'
        } else {
            return <div>
                <span>{data.ProductsCreatedNumber + data.ProductsPlusOneNumber}</span>
                <span> ( </span>
                {data.ProductsCreatedNumber > 0 ?
                    productsCreatedLink : <span>{data.ProductsCreatedNumber}</span>
                }
                <span> / </span>
                {data.ProductsPlusOneNumber > 0 ?
                    productsPlusOneLink : <span>{data.ProductsPlusOneNumber}</span>
                }
                <span> )</span>
            </div>
        }

    }
}

const threePLSellerProductsCreated = {
    'label': '3PL Seller products created', value: '3PLSellerProductsCreated',
    queryParams: {
        action:'3PLSellerProductsCreated',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    },
    "endpoint": "/run-process",
    'type':'post',
    format: (data, params={}) => {

        data.ProductsCreatedNumber =_.size(data['3PLSellerProductsCreated'].ProductsCreated)
        data.ProductsPlusOneNumber =_.size(data['3PLSellerProductsCreated'].ProductsPlusOne)

        if ( data.ProductsCreatedNumber>0&& data.ProductsCreatedNumber <1000) {
            var productsCreatedLink = linkFormatter({}, data, {
                labelPath: ['ProductsCreatedNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item['3PLSellerProductsCreated'].ProductsCreated, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }else{
            var productsCreatedLink =data.ProductsCreatedNumber
        }
        if (  data.ProductsPlusOneNumber>0&& data.ProductsPlusOneNumber <1000) {
            var productsPlusOneLink = linkFormatter({}, data, {
                labelPath: ['ProductsPlusOneNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item['3PLSellerProductsCreated'].ProductsPlusOne, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }else{
            var productsPlusOneLink =data.ProductsPlusOneNumber
        }
        if (_.includes(['sendemail','download'],params.type) ){
            return (data.ProductsCreatedNumber + data.ProductsPlusOneNumber) +' ( '+data.ProductsCreatedNumber + ' / ' +data.ProductsPlusOneNumber + ' )'
        } else {
            return <div>
                <span>{data.ProductsCreatedNumber + data.ProductsPlusOneNumber}</span>
                <span> ( </span>
                {data.ProductsCreatedNumber > 0 ?
                    productsCreatedLink : <span>{data.ProductsCreatedNumber}</span>
                }
                <span> / </span>
                {data.ProductsPlusOneNumber > 0 ?
                    productsPlusOneLink : <span>{data.ProductsPlusOneNumber}</span>
                }
                <span> )</span>
            </div>
        }

    }
}

const gbgInventoryProductsCreated = {
    label: 'GBG inventory products created', 
    value: 'PartnerPurchasedProductsCreated',
    queryParams: {
         action:'PartnerPurchasedProductsCreated',
         waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    },
    "endpoint": "/run-process",
    'type':'post',
    format: (data, params) => {
        data.ProductsCreatedNumber =_.size(data.PartnerPurchasedProductsCreated.ProductsCreated)
        data.ProductsPlusOneNumber =_.size(data.PartnerPurchasedProductsCreated.ProductsPlusOne)

        if (data.ProductsCreatedNumber>0 && data.ProductsCreatedNumber <1000) {
            var productsCreatedLink = linkFormatter({}, data, {
                labelPath: ['ProductsCreatedNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.PartnerPurchasedProductsCreated.ProductsCreated, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }else{
            var productsCreatedLink =data.ProductsCreatedNumber
        }
        if (data.ProductsPlusOneNumber>0&& data.ProductsPlusOneNumber <1000) {
            var productsPlusOneLink = linkFormatter({}, data, {
                labelPath: ['ProductsPlusOneNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.PartnerPurchasedProductsCreated.ProductsPlusOne, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }else{
            var productsPlusOneLink =data.ProductsPlusOneNumber
        }
        if (_.includes(['sendemail','download'],params.type) ){
            return (data.ProductsCreatedNumber + data.ProductsPlusOneNumber) +' ( '+data.ProductsCreatedNumber + ' / ' +data.ProductsPlusOneNumber + ' )'
        } else {
            return <div>
                <span>{data.ProductsCreatedNumber + data.ProductsPlusOneNumber}</span>
                <span> ( </span>
                {data.ProductsCreatedNumber > 0 ?
                    productsCreatedLink : <span>{data.ProductsCreatedNumber}</span>
                }
                <span> / </span>
                {data.ProductsPlusOneNumber > 0 ?
                    productsPlusOneLink : <span>{data.ProductsPlusOneNumber}</span>
                }
                <span> )</span>
            </div>
        }
    }
}

const productsPushedLive = {
        label: 'Products Pushed Live', 
        value: 'ProductsPushedLive', queryParams: {
        action: 'ProductsPushedLive',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    }, type: 'post',  "endpoint": "/run-process", format: (data, params) => {
        return _.get(data, 'ProductsPushedLive')
    }
}


const averageTimeToPostAProduct = {
    label: 'Average time to post a product', 
    value: 'AverageTimeToPostProduct', queryParams: {
    action: 'AverageProductTimeToPost',
    fromDate: 'from_date',
    toDate: 'to_date',
   }, type: 'post', endpoint: '/process-action', format:(data,params={}) => {
     if (_.get(data, 'TotalWorkingTimeDuration', 0) > 0 && _.get(data, 'TotalProductsPosted', 0)  >0) {
        var totalDuration = convertToHoursAndMinutes(moment.duration(data.TotalWorkingTimeDuration), {format: 'hours_and_minutes'})
        var postedProductsLink =   data.ProductsPostedTotalNumber = _.get(data, 'ProductsPosted', []).length
        var productsPlusOneLink =  data.ProductsPlusOneTotalNumber
        var prelistingsPostedCreatedLink =data.TotalPrelistingsPostedCreated = _.get(data, 'PrelistingsPostedCreated', []).length
        var prelistingsNotPostedCreatedLink =data.TotalPrelistingsNotPostedCreated = _.get(data, 'PrelistingsNotPostedCreated', []).length

        var averageTimeLInk = data.AverageProductTimeToPost =   convertToHoursAndMinutes( moment.duration(data.TotalWorkingTimeDuration / data.TotalProductsPosted), {format: 'hours_minutes_seconds'})

        if (_.size(_.get(data, 'WorkingTimeRecords', []))  <1000) {
            data.totalDuration =totalDuration
            averageTimeLInk = linkFormatter({}, data, {
                labelPath: ['AverageProductTimeToPost'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.WorkingTimeRecords, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/time-tracking?[queryParams]',
            })
        }

        if ( data.TotalPrelistingsPostedCreated <1000) {
            prelistingsPostedCreatedLink = linkFormatter({}, data, {
                labelPath: ['TotalPrelistingsPostedCreated'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.PrelistingsPostedCreated, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }
        if ( data.TotalPrelistingsNotPostedCreated <1000) {
            prelistingsNotPostedCreatedLink = linkFormatter({}, data, {
                labelPath: ['TotalPrelistingsNotPostedCreated'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.PrelistingsNotPostedCreated, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }
        if ( data.ProductsPlusOneTotalNumber <1000) {
              productsPlusOneLink = linkFormatter({}, data, {
                labelPath: ['ProductsPlusOneTotalNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.ProductsPlusOneRecords, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }
        if ( data.ProductsPostedTotalNumber <1000) {
            postedProductsLink = linkFormatter({}, data, {
                labelPath: ['ProductsPostedTotalNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.ProductsPosted, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }

        if (_.includes(['sendemail','download'],params.type) ){
            return data.AverageProductTimeToPost   +' ( '+_.get(data, 'TotalProductsPosted', 0) + ' )'
        } else {
            return <div style={{margin:'0 auto',  maxWidth:270}} className="align-text-left">
                <div>
                    <span className="">Average time:</span>
                   <span className="pleft7">{averageTimeLInk}</span>
                </div>
                <div>
                    <span className="">Total products:</span>
                    <span className="pleft7">{_.get(data, 'TotalProductsPosted', 0) }</span>
                </div>
                <div>
                    <span className="">Products posted directly:</span>
                    <span className="pleft7">{postedProductsLink}</span>
                </div>
                <div>
                    <span className="">Pre-listings created (finalized) :</span>
                    <span className="pleft7">{prelistingsPostedCreatedLink}</span>
                </div>
                <div>
                    <span className="">Pre-listings created (not finalized):</span>
                    <span className="pleft7">{prelistingsNotPostedCreatedLink}</span>

                </div>
                <div>
                    <span className="">Products +1:</span>
                    <span className="pleft10">{productsPlusOneLink}</span>

                </div>

            </div>
        }


    } else {
        return 'n/a';
    }

    }
}

const productsItemsCreated = {
    label: 'Product items created',
    value: 'ProductItemsCreated', queryParams: {
        action: 'ProductItemsCreated',
        sellerID: 'seller_id',
        fromDate: 'from_date',
        toDate: 'to_date',
    }, type: 'post', endpoint: '/process-action', format: function (data, params = {}) {
        const self = this
        const {ProductItemsCreated, TotalProductItemsCreated, ListingsCreated} = data
        let listingsCreatedLink
         data.postedProductsTotalNumber = ListingsCreated.length
        if (data.postedProductsTotalNumber > 0) {
            listingsCreatedLink = data.postedProductsTotalNumber
        }

        data.listingsTotalNumber = data.ListingsCreated.length
        if (data.postedProductsTotalNumber < 1000) {
            listingsCreatedLink = linkFormatter({}, data, {
                labelPath: ['listingsTotalNumber'],
                path: 'getObject',
                formatPathValue: (item) => {
                const recordIDs = _.map(item.ListingsCreated, (itemID) => encodeURIComponent(itemID));
                    return 'recordIDs=' + recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }
        if (TotalProductItemsCreated > 0) {
            if (['sendemail', 'download'].includes(params.type)) {
                return `Listings created: ${data.postedProductsTotalNumber}; Product items created: ${TotalProductItemsCreated}`
            } else {
                 return <div style={{margin:'0 auto',  maxWidth:270}} className="align-text-left">
                    <div className="bot10">
                        <span className="">Listings created:</span>
                        <span className="pleft7">{listingsCreatedLink}</span>
                    </div>
                    <div className="bot10" style={{position:'relative'}}>
                        <span className="">Product items created:</span>
                        <span className="pleft7">{TotalProductItemsCreated}</span>
                          <Link style={{position:'absolute', right:5}} className="  cursor-pointer   pull-right" onClick={() => {
                          self.downloadDataForKPIReport.call(self,({
                            dataToDownload:ProductItemsCreated.map(productItem=>{
                                return {
                                    ...productItem,
                                    CreatedAt:moment(productItem.CreatedAtDate).format('YYYY-MM-DD HH:mm')
                                }
                            }),
                            fields: [
                                {value: 'ProductItemSKU', default: '', label: 'SKU'},
                                {value: 'ProductItemLocation', default: '', label: 'Location'},
                                {value: 'ProductItemQuantity', default: '', label: 'Qty'},
                                {value: 'ProductItemStatus', default: '', label: 'Status'},
                                {value: 'TrackingNumber', default: '', label: 'Tracking Number'},
                                {value: 'CreatedAt', default: '', label: 'Created At'},
                                {value: 'ProcessedByUser', default: '', label: 'Created By'},
                                {value: 'MarketName', default: '', label: 'Product Market'},
                            ]
                        }))

                    }}><FaDownload style={{fontSize: 24}}></FaDownload></Link>
                    </div>
                    {data.TotalPartnerProductWebhookEvents !== 'n/a' &&
                    <div>
                        <span className="">Babylist webhook requests sent:</span>
                        <span className="pleft7">{data.TotalPartnerProductWebhookEvents}</span>
                    </div>
                    }
                </div>
            }
        } else {
            return 'n/a';
        }
    }
}

const averageTimeToFinalizeAProduct = {
    label: 'Average time to finalize a product', 
    value: 'AverageTimeToFinalizeProduct', queryParams: {
    action: 'AverageProductTimeToFinalize',
    fromDate: 'from_date',
    toDate: 'to_date',
    }, type: 'post', endpoint: '/process-action', format: (data, params={}) => {
     if (_.get(data, 'TotalWorkingTimeDuration', 0) > 0 && _.get(data, 'TotalProductsFinalized', 0)  >0) {
        var totalDuration = convertToHoursAndMinutes(moment.duration(data.TotalWorkingTimeDuration), {format: 'hours_and_minutes'})

        var duration = moment.duration(data.TotalWorkingTimeDuration / data.TotalProductsFinalized)

        var averageTime =data.AverageProductTimeToFinalize =convertToHoursAndMinutes(duration, {format: 'hours_minutes_seconds'})
        if (_.size(_.get(data, 'WorkingTimeRecords', []))  <1000) {
            data.totalDuration =totalDuration
              averageTime = linkFormatter({}, data, {
                labelPath: ['AverageProductTimeToFinalize'],
                path: 'getObject',
                formatPathValue: (item) => {
                     var recordIDs = _.map(item.WorkingTimeRecords, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/time-tracking?[queryParams]',
            })
        }

        if ( _.get(data, 'TotalProductsFinalized', 0)  <1000) {
            var productsFinalizedLink = linkFormatter({}, data, {
                labelPath: ['TotalProductsFinalized'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.ProductsFinalized, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }else{
            var productsFinalizedLink =data.TotalProductsFinalized
        }
        if (_.includes(['sendemail','download'],params.type) ){
            return averageTime +' ( '+_.get(data, 'TotalProductsFinalized', 0) + ' )'
        } else {
            return <div>
                <span>{ _.size(_.get(data, 'WorkingTimeRecords', [])) ?
                    averageTime : <span>{averageTime}</span>
                }</span>
                <span> ( </span>
                { _.get(data, 'TotalProductsFinalized', 0) ?
                    productsFinalizedLink : <span>{_.get(data, 'TotalProductsFinalized', 0)}</span>
                }
                <span> )</span>
            </div>
        }


    } else {
        return 'n/a';
    }
}
}

const averageTimeToPutAProductAway = {
    label: 'Average time to put a product away', 
    value: 'AverageTimeToPutAwayProduct', 
    queryParams: {
    action: 'AverageTimeToPutAwayProduct',
    fromDate: 'from_date',
    toDate: 'to_date',
    }, type: 'post', endpoint: '/process-action', format: (data, params) => {
      if (_.get(data, 'TotalWorkingTimeDuration', 0) > 0 && _.get(data, 'TotalProductsPutAway', 0)  >0) {
         var duration  = moment.duration(data.TotalWorkingTimeDuration / data.TotalProductsPutAway)
        
        var averageTime =data.AverageTimeToPutProductAway = convertToHoursAndMinutes(duration, {format: 'hours_minutes_seconds'})

        if (_.size(_.get(data, 'WorkingTimeRecords', []))  <1000) {

            averageTime = linkFormatter({}, data, {
                labelPath: ['AverageTimeToPutProductAway'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.WorkingTimeRecords, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/time-tracking?[queryParams]',
            })
        }

        if ( _.get(data, 'TotalProductsPutAway', 0)  <1000) {
            var productsLink = linkFormatter({}, data, {
                labelPath: ['TotalProductsPutAway'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.ProductsPutAway, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/products?[queryParams]',
            })
        }else{
            var productsLink =data.TotalProductsPutAway
        }
        if (_.includes(['sendemail','download'],params.type) ){
            return averageTime +' ( '+_.get(data, 'TotalProductsPutAway', 0) + ' )'
        } else {
            return <div>
                <span>{ _.size(_.get(data, 'WorkingTimeRecords', [])) ?
                    averageTime : <span>{averageTime}</span>
                }</span>
                <span> ( </span>
                { _.get(data, 'TotalProductsPutAway', 0) ?
                    productsLink : <span>{_.get(data, 'TotalProductsPutAway', 0)}</span>
                }
                <span> )</span>
            </div>
        }


    } else {
        return 'n/a';
    }
    }
}

const averageTimeToFulfillAProduct = {
    label: 'Average time to fulfill a product', 
    value: 'AverageTimeToFulfillProduct', queryParams: {
    action: 'AverageTimeToFulfillProduct',
    fromDate: 'from_date',
    toDate: 'to_date',
    }, type: 'post', endpoint: '/process-action', format: (data, params) => {
    params["useAnalyticDatabase"] = true
    if (_.get(data, 'TotalWorkingTimeDuration', 0) > 0 && _.get(data, 'TotalTransactionsFulfilled', 0)  >0) {
       // var duration = moment.duration(data.TotalWorkingTimeDuration / data.TotalTransactionsFulfilled)
      //  return convertToHoursAndMinutes(duration, {format: 'hours_and_minutes'})
        var duration  = moment.duration(data.TotalWorkingTimeDuration / data.TotalTransactionsFulfilled)

        var averageTime =data.AverageTimeToFulfillProduct = convertToHoursAndMinutes(duration, {format: 'hours_minutes_seconds'})
        if (_.size(_.get(data, 'WorkingTimeRecords', []))  <1000) {

            averageTime = linkFormatter({}, data, {
                labelPath: ['AverageTimeToFulfillProduct'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.WorkingTimeRecords, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/time-tracking?[queryParams]',
            })
        }

        if ( _.get(data, 'TotalTransactionsFulfilled', 0)  <1000) {
            var productsLink = linkFormatter({}, data, {
                labelPath: ['TotalTransactionsFulfilled'],
                path: 'getObject',
                formatPathValue: (item) => {
                    var recordIDs = _.map(item.TransactionsFulfilled, itemID => {
                        return encodeURIComponent(itemID)
                    })
                    return 'recordIDs=' +recordIDs.join(',')
                },
                placeholder: '[queryParams]',
                template: config.getEnvironment().serverBaseURL + '/admin/payout-registry?[queryParams]',
            })
        }else{
            var productsLink =data.TotalTransactionsFulfilled
        }

        if (_.includes(['sendemail','download'],params.type) ){
            return averageTime +' ( '+_.get(data, 'TotalTransactionsFulfilled', 0) + ' )'
        } else {
            return <div>
                <span>{ _.size(_.get(data, 'WorkingTimeRecords', [])) ?
                    averageTime : <span>{averageTime}</span>
                }</span>
                <span> ( </span>
                { _.get(data, 'TotalTransactionsFulfilled', 0) ?
                    productsLink : <span>{_.get(data, 'TotalTransactionsFulfilled', 0)}</span>
                }
                <span> )</span>
            </div>
        }
    } else {
        return 'n/a';
    }
}
}

const orderValueFulfilled = {
    label: 'Order Value Fulfilled', 
    value: 'OrderValueFulfilled', queryParams: {
    action: 'OrderValueFulfilled',
    waitForResponse:true,
    from: 'from_date',
    to: 'to_date',
 }, type: 'post',  "endpoint": "/run-process",
    format: (data, params={}) => {

        data.RecordsTotalNumber =_.size(data.OrderValueFulfilled.RecordIDs)
        data.TotalSalesAmount=formatNumbers.formatMoney(_.get(data, 'OrderValueFulfilled.Value', 0))
        if (data.RecordsTotalNumber > 0 ) {


            if (  data.RecordsTotalNumber  <1000) {
                var saleTransactionsLink = linkFormatter({}, data, {
                    labelPath: ['TotalSalesAmount'],
                    path: 'getObject',
                    formatPathValue: (item) => {
                         var recordIDs = _.map(item.OrderValueFulfilled.RecordIDs, itemID => {
                            return encodeURIComponent(itemID)
                        })
                        return 'recordIDs=' +recordIDs.join(',')
                    },
                    placeholder: '[queryParams]',
                    template: config.getEnvironment().serverBaseURL + '/admin/payout-registry?[queryParams]',
                })
            }else{
                var saleTransactionsLink = data.TotalSalesAmount
            }


            if (_.includes(['sendemail','download'],params.type) ){
                return   formatNumbers.formatMoney(_.get(data, 'OrderValueFulfilled.Value', 0))
            } else {
                return <div>

                    {_.get(data, 'OrderValueFulfilled.Value', 0) >0 ?
                        saleTransactionsLink : <span>{ data.TotalSalesAmount}</span>
                    }

                </div>
            }
        } else {
            return 'n/a';
        }

    }

}

const sellerProductsPushedLive = {
    label: 'Seller Products Pushed Live', 
    value: 'SellerProductsPushedLive', queryParams: {
        action: 'SellerProductsPushedLive',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    }, 
    type: 'post',  
    endpoint: "/run-process", 
    format: (data, params) => {
        return _.get(data, 'SellerProductsPushedLive')
    }
}

const gBGProductsPushedLive =  {
    'label': 'GBG Products Pushed Live', 
    value: 'GBGProductsPushedLive', 
    queryParams: {
        action: 'GBGProductsPushedLive',
        waitForResponse:true,
        from: 'from_date',
        to: 'to_date',
    }, 
    type: 'post',  
    endpoint: "/run-process", 
    format: (data, params) => {
        return  _.get(data, 'GBGProductsPushedLive')
    }
}

const  shippingOrdersCreated = {
    label: 'Shipping orders created', 
    value: 'ShippingOrdersCreated',
    queryParams: {
        OrderShippingType: ['Shipping'],
        fromCreateTime: 'from_date',
        toCreateTime: 'to_date',
    },
    endpoint: '/transactions', 
    format: (data) => {
        return _.get(data, 'total')
    }
}

const mercariOrders = {
    label: 'Mercari orders', 
    value: 'MercariOrders', queryParams: {
    ShopifyOrderCustomerIDs: ['663957733479'],
        fromCreateTime: 'from_date',
        toCreateTime: 'to_date',
    }, endpoint: '/transactions', 
    format: (data) => {
        return _.get(data, 'total')
    }
}

const allReportFieldList = [
    dropOffsCreated,
    pickUpsCreated,
    dropOffSchedule,
    pickUpsSchedule,
    dropOffReceived,
    pickupsReceived,
    dropOffsCancelled,
    pickupsCancelled,
    productsPushedLive,
    productsItemsCreated,
    mercariOrders,        
    shippingOrdersCreated,
    sellerProductsPushedLive,    
    gBGProductsPushedLive,
    deliveryItemsFulfilled,
    shippingItemsFulfilled,
    curbsidePickupFulfilled,
    averageTimeToFinalizeAProduct,
    averageTimeToPutAProductAway,
    averageTimeToFulfillAProduct,
    orderValueFulfilled,
    threePLSellerProductsCreated,
    averageTimePerPickupAndGBGOrderDelivery,
    averageTimeToPostAProduct,
    gbgInventoryProductsCreated,
    sellerProductsCreated]

class KPIReportsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        var reportFields=   _.isUndefined(this.props.location.query.reportFields) ?  allReportFieldList : _.isArray(this.props.location.query.reportFields) ? _.map(this.props.location.query.reportFields, function (item) {
                return _.find(allReportFieldList, {value:item})
            }) : [_.find(allReportFieldList, {value:this.props.location.query.reportFields})]
        var selectedMarkets = _.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
            var location = _.find(config.warehouseData, function (o) {
                return o.MarketName == item
            });
            if (location) {
                return {'value': item, 'label': location.MarketName}
            }
        })
        var timeZoneName = 'America/Denver'
        var filterOptions = {
            SellerID:_.isUndefined(this.props.location.query.SellerID) ? 'all' : this.props.location.query.SellerID
        }
        var fromDate ='', toDate ='', reportDate=''
        if (this.props.location.query.from){
            if (isIsoDate(this.props.location.query.from)) {
                fromDate=     momentTimeZone(this.props.location.query.from).tz(timeZoneName)
            }else{
                fromDate=  moment(this.props.location.query.from, 'MM-DD-YYYY-HH-mm')
            }
        }
        if (this.props.location.query.to){
            if (isIsoDate(this.props.location.query.to)) {
                toDate=     momentTimeZone(this.props.location.query.to).tz(timeZoneName)
            }else{
                 toDate=  moment(this.props.location.query.to, 'MM-DD-YYYY-HH-mm')
            }
        }
        if (this.props.location.query.date){
            if (isIsoDate(this.props.location.query.date)) {
                reportDate=     momentTimeZone(this.props.location.query.date).tz(timeZoneName)
            }else{
                reportDate=  moment(this.props.location.query.date, 'MM-DD-YYYY-HH-mm')
            }
        }
         this.state = {
            pending: false,
            'from':fromDate,
            'to':  toDate,
             reportDate:reportDate,
            Markets:selectedMarkets,
            KPIReportData:[],
             DailyKPIReportData:[],
             filterOptions: filterOptions,
            reportFields:  reportFields
        };
        this.context.router.push('/admin/reports');
     }
     fetchAllSellerList(){
          if (this.props.allSellersList.data.length == 0) {
             if(this.state.filterOptions.SellerID !== 'all') {
                 this.setState({pending: true})
             }

             var methodData = {
                 "success_event": FETCH_ALL_SELLERS_LIST,
                 "endpoint": "/sellers",
                 'not_display_success_message': true
             };
             this.props.makeRequest({sortBy:'DisplayName:1',all:true, include:['DisplayName','InventoryOwnership']}, methodData).then(response=>{
                   this.setState({pending:false})
             }).catch(err => {
                 this.setState({pending:false})
             });
         }
         this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
             label: 'DisplayName',
             value: '_id'
         })
         this.allSellersOptionsList.unshift({label: 'All', value: 'all'});
     }
    componentWillMount() {
        if(this.state.reportFields.find(item=>item.value == 'ProductItemsCreated')){
            this.fetchAllSellerList()
        }
        this.fetchReportSettings()
    }
    componentWillReceiveProps(nextProps) {

        if (nextProps.allSellersList.data.length !==  this.props.allSellersList.data.length) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })

        }
    }
    fetchReportSettings() {
        var self = this
        this.props.makeRequest({Name: 'ReportSettings'}, {
            "endpoint": "/settings",
            'not_display_error_message': true,

        }).then(function (res) {

            self.ReportSettings = _.get(res.data.data, [0, 'Data'], {})
        })
    }
    getReportData(params={}) {
        var self = this
        if (!self.state.from || !self.state.to){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify date range'
            });
        }
        this.setState({pending:true})
       var queryData = self.updateURL()
         return new Promise((resolve, reject) => {

            var functionsToCall = {};
            var copyOfReportFields = _.cloneDeep(this.state.reportFields)
            _.forEach(copyOfReportFields, function (field, index) {
                 _.forEach(field.queryParams, (value, key) => {

                    if (value == 'from_date') {
                        field.queryParams[key] =  queryData.from
                    }

                     if (value == 'seller_id' && self.state.filterOptions.SellerID !== 'all') {
                         field.queryParams.SellerID = self.state.filterOptions.SellerID
                     }

                    if (value == 'to_date') {
                        field.queryParams[key] =queryData.to
                    }

                    if (_.size( self.state.Markets)){
                        field.queryParams.Markets =_.map(self.state.Markets, 'value')
                    }

                     if (key == 'customQueriesData') {
                        _.forEach(field.queryParams.customQueriesData, (innerValue, innerKey) => {

                            if (innerValue == 'from_date') {
                                field.queryParams['customQueriesData'][innerKey] = queryData.from
                            }
                            if (innerValue == 'to_date') {
                                field.queryParams['customQueriesData'][innerKey] = queryData.to
                            }

                        })
                    }
                })

                functionsToCall[field.label] = function (done) {
                     field.queryParams["useAnalyticDatabase"] = true
                     return self.props.makeRequest(field.queryParams, {
                        "labelFrontEnd": field.label,
                        "endpoint": field.endpoint,
                        type: _.get(field, 'type'),
                        'not_display_success_message': true
                    }).then(function (res) {
                           done(null, field.format.call(self,res.data, params))
                    }).catch(err => {
                        console.log('err', err  );
                        done(err)
                    });
                }

            })

            var loadingResults = []
            _.map(functionsToCall, (functionReport, reportName) => {
                loadingResults.push({Title: reportName, Value: "Loading"})
            })

            
            
            async.series(functionsToCall,
                function (err, results) {
                    self.setState({pending:false})
                    
                    if (err) {
                         return resolve()
                    }

                    var resultsAsArray = _.map(results, (value, field) => {
                        return {Title: field, Value: value}
                    })

                    resultsAsArray =_.sortBy(resultsAsArray, function(item){
                        return _.findIndex(self.state.reportFields, field=>{
                            return  field.label == item.Title
                        })
                    });

                    self.setState({KPIReportData:resultsAsArray,DailyKPIReportData:[]})

                    if (params.type == 'download') {
                        self.downloadReport(resultsAsArray)
                    } else if (params.type == 'sendemail') {
                        self.sendKPIReportDataEmail()
                    }
                    resolve(results)
                })
        })
    }
    downloadDataForKPIReport({dataToDownload, fields}) {
         let csvData = json2csv.parse(dataToDownload, {
            fields:fields
        })
        let filename
        if (this.state.from.isSame(this.state.to,'day')){
              filename = `product_items_created_on_${this.state.from.format("YYYY_MM_DD")}.csv`
        } else {
            filename = `product_items_created_from_${this.state.from.format("YYYY_MM_DD")}_to_${this.state.to.format("YYYY_MM_DD")}.csv`
         }
        var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

    }
    downloadReport(results) {
        var dataToExport = _.map(results, function (recordData) {
            return recordData
        })
        var csvData = json2csv.parse(dataToExport, {
            fields: [
                {value: 'Title', default: '', label: 'Title'},
                {value: 'Value', default: '', label: 'Value'}
            ],
        })

        if (this.state.from.isSame(this.state.to,'day')){
            var filename = "kpi_report_for_" + this.state.from.format("YYYY-MM-DD")+".csv";

        } else {
            var filename = "kpi_report_from_" + this.state.from.format("YYYY-MM-DD") + "_to_" + this.state.to.format("YYYY-MM-DD") + ".csv";
        }
       var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

    }
    sendKPIReportDataEmail() {
        var self = this;
        var data = {
            action: 'SendKPIReportEmail',
            KPIReportData:  this.state.KPIReportData,
            DailyKPIReportData:[],
            emailAddress: this.state.emailAddress,
            fromDate:self.state.from.startOf('day').toISOString(),
            toDate:self.state.to.endOf('day').toISOString()
        }


        var methodData = {
            type: 'post',
            "endpoint": "/process-action",
            'not_display_success_message': true,
        };
        data["useAnalyticDatabase"] = true
        return this.props.makeRequest(data, methodData).then(res => {
            return this.props.displayMessage({
                'messageCode': 'KPI report data sent'
            });
        }).catch(err => {

        });
    }

    getDailyKPIReportData(params={}) {
        var self = this

        this.setState({pending:true})
     self.updateURL({type:'DailyKPIReport'})
        return new Promise((resolve, reject) => {
            var functionsToCall = {};
            _.forEach(_.map(config.warehouseData,'MarketName'), function (MarketName, index) {
                var queryParams = {
                    "Types": ["DailyKPIReportData"],
                    Markets: [MarketName],
                    fromTime: self.state.date.startOf('day').toISOString(),
                    toTime: self.state.date.endOf('day').toISOString(),
                    sortBy: 'createdAt' + ':' + (-1),
                } 

 
                functionsToCall[MarketName] = function (done) {
                    queryParams["useAnalyticDatabase"] = true
                    return self.props.makeRequest(queryParams, {
                        'endpoint': '/historical_data',
                        'not_display_success_message': true
                    }).then(function (res) {
                        done(null, res.data)
                    }).catch(err => {
                        done(err)
                    });
                }
            })
            async.parallel(functionsToCall,
                function (err, results) {

                    self.setState({pending: false})
                    if (err) {
                        return resolve()
                    }

                    var KPIDataMap =  [
                        {
                            groupTitle: 'Services',
                            title: 'New Dropoffs created',
                            value: 'DropoffCreated',
                            format: (data) => {
                                return _.get(data, 'CustomData.DropoffCreated.Value', '')
                            }
                        },
                        {
                            groupTitle: '',
                            title: 'New Pickups created',
                            value: 'PickupCreated',
                            format: (data) => {
                                return _.get(data, 'CustomData.PickupCreated.Value', '')
                            }
                        },
                        {
                            groupTitle: '',
                            title: 'Completed Dropoff (Completed %)',

                            format: (data) => {
                                return _.get(data, 'CustomData.DropoffCreated.Value', '')
                            },

                        },
                        {
                            groupTitle: 'Fulfillment',
                            title: 'Delivery (items)',

                            format: (data) => {
                                return _.get(data, 'CustomData.DeliveryItemsFulfilled.Value', '')
                            }
                        },
                        {
                            groupTitle: '',
                            title: 'Shipping (items)',
                         //   value: 'ShippingItemsFulfilled',
                            format: (data) => {
                                return _.get(data, 'CustomData.ShippingItemsFulfilled.Value', '')
                            }
                        },
                        {
                            groupTitle: '',
                            title: 'Avg time to fulfill per item (mins)',
                            goals:Math.floor(_.get(self.ReportSettings,'AverageTimeToFulfillProduct',0) /60) + ' min',

                            format: (data) => {
                                return _.get(data, 'CustomData.AverageTimeToFulfillProduct.Value',-1) ? '' : Math.floor(_.get(data, 'CustomData.AverageTimeToFulfillProduct.Value',-1) / 60)
                            },
                            getStyle: (data) => {
                                if(_.get(data, 'CustomData.AverageTimeToFulfillProduct.Value',-1) == -1){
                                    return  {}
                                } else{
                                    if ( _.get(data, 'CustomData.AverageTimeToFulfillProduct.Value',-1)   > self.ReportSettings.AverageTimeToFulfillProduct){
                                        return  {color:'red'}
                                    } else{
                                        return  {color:'green'}
                                    }
                                }
                            }
                        },
                        {
                            groupTitle: '',
                            title: 'Avg time to put away per item (mins)',
                            value: 'AverageTimeToPutAwayProduct',
                            goals:Math.floor(_.get(self.ReportSettings,'AverageTimeToPutAwayProduct',0) /60) + ' min',
                            format: (data) => {
                                return _.get(data, 'CustomData.AverageTimeToPutAwayProduct.Value',-1)== -1 ? '' : Math.floor(_.get(data, 'CustomData.AverageTimeToPutAwayProduct.Value',-1) / 60)

                            },
                            getStyle: (data) => {
                                if(_.get(data, 'CustomData.AverageTimeToPutAwayProduct.Value',-1) == -1){
                                    return  {}
                                } else{
                                    if ( _.get(data, 'CustomData.AverageTimeToPutAwayProduct.Value',-1)   > self.ReportSettings.AverageTimeToPutAwayProduct){
                                        return  {color:'red'}
                                    } else{
                                        return  {color:'green'}
                                    }
                                }
                            }
                        },
                        {
                            groupTitle: '',
                            title: 'Time per pickup / delivery  (time/event)',
                            goals:Math.floor(_.get(self.ReportSettings,'AverageTimePerPickupAndDelivery',0) /60) + ' min',
                            format: (data) => {
                                return _.get(data, 'CustomData.AverageTimePerPickupAndDelivery.Value',-1)== -1 ? '' : Math.floor(_.get(data, 'CustomData.AverageTimePerPickupAndDelivery.Value',-1) / 60)

                            },
                            getStyle: (data) => {
                                if(_.get(data, 'CustomData.AverageTimePerPickupAndDelivery.Value',-1) == -1){
                                    return  {}
                                } else{
                                    if ( _.get(data, 'CustomData.AverageTimePerPickupAndDelivery.Value',-1)   > self.ReportSettings.AverageTimePerPickupAndDelivery){
                                        return  {color:'red'}
                                    } else{
                                        return  {color:'green'}
                                    }
                                }
                            }
                        },
                        {
                            groupTitle: 'Products',
                            title: 'SellerConsigned created (prelisting /listing/+1)',
                            value: 'SellerProductsCreated',
                            format: (data) => {
                                if(_.get(data, 'CustomData.SellerProductsCreated.Value', '') ==''){
                                    return ''
                                }
                              return _.get(data, 'CustomData.SellerProductsCreated.Value', '') + ' ( '+_.get(data, 'CustomData.SellerProductsCreated.ProductsCreated', '') + ' / ' + _.get(data, 'CustomData.SellerProductsCreated.ProductsPlusOne', '')+' )'
                            }
                        },
                        {
                            groupTitle: '',
                            title: 'PartnerConsigned created  (prelisting /listing/+1)',

                            format: (data) => {
                                if(_.get(data, 'CustomData.PartnerSellerProductsCreated.Value', '') ==''){
                                    return ''
                                }
                                return _.get(data, 'CustomData.PartnerSellerProductsCreated.Value', '') + ' ( '+_.get(data, 'CustomData.PartnerSellerProductsCreated.ProductsCreated', '') + ' / ' + _.get(data, 'CustomData.PartnerSellerProductsCreated.ProductsPlusOne', '')+' )'

                            }
                        },
                        {
                            groupTitle: '',
                            title: 'PartnerPurchased created (prelisting/ listing/+1)',

                            format: (data) => {
                                if(_.get(data, 'CustomData.PartnerPurchasedProductsCreated.Value', '') ==''){
                                    return ''
                                }
                                return _.get(data, 'CustomData.PartnerPurchasedProductsCreated.Value', '') + ' ( '+_.get(data, 'CustomData.PartnerPurchasedProductsCreated.ProductsCreated', '') + ' / ' + _.get(data, 'CustomData.PartnerPurchasedProductsCreated.ProductsPlusOne', '')+' )'
                            }
                        },
                        {
                            groupTitle: '',
                            title: 'Avg time to post product (mins)',
                            goals:Math.floor(_.get(self.ReportSettings,'AverageProductTimeToPost',0) /60) + ' min',
                            format: (data) => {
                                return _.get(data, 'CustomData.AverageProductTimeToPost.Value',-1)== -1 ? '' : Math.floor(_.get(data, 'CustomData.AverageProductTimeToPost.Value',-1) / 60)

                            },
                            getStyle: (data) => {
                                if(_.get(data, 'CustomData.AverageProductTimeToPost.Value',-1) == -1){
                                    return  {}
                                } else{
                                    if ( _.get(data, 'CustomData.AverageProductTimeToPost.Value',-1)   > self.ReportSettings.AverageProductTimeToPost){
                                        return  {color:'red'}
                                    } else{
                                        return  {color:'green'}
                                    }
                                }
                            }

                        },
                        {
                            groupTitle: '',
                            title: 'Products Finalized ',

                            format: (data) => {
                                return _.get(data, 'CustomData.AverageTimeToFinalizeProduct.TotalProductsFinalized', '')

                            }
                        },
                        {
                            groupTitle: '',
                            title: 'Avg time to finalize a product (mins)',
                            goals: Math.floor(_.get(self.ReportSettings,'AverageTimeToFinalizeProduct',0) /60) + ' min',
                            format: (data) => {
                                 return _.get(data, 'CustomData.AverageTimeToFinalizeProduct.Value',-1)== -1 ? '' : Math.floor(_.get(data, 'CustomData.AverageTimeToFinalizeProduct.Value',-1) / 60)
                            },
                            getStyle: (data) => {
                                if(_.get(data, 'CustomData.AverageTimeToFinalizeProduct.Value',-1) == -1){
                                    return  {}
                                } else{
                                    if ( _.get(data, 'CustomData.AverageTimeToFinalizeProduct.Value',-1)   > self.ReportSettings.AverageTimeToFinalizeProduct){
                                        return  {color:'red'}
                                    } else{
                                        return  {color:'green'}
                                    }
                                }
                             }
                        },

                    ]
                    var tableRows = _.map(KPIDataMap, (item) => {
                        var rowData = _.pick(item, ['groupTitle', 'title', 'goals'])
                        _.forEach(results, ( data,MarketName) => {
                            rowData[MarketName+'_value'] = item.format(_.get(data,'data.0',{}))
                            rowData[MarketName+'_cell_style'] =item.getStyle ?  item.getStyle(_.get(data,'data.0',{})) : {};
                        })
                        return rowData
                    })

                    self.setState({DailyKPIReportData: tableRows, KPIReportData: []})

                    resolve(results)
                })
        })

    }
    updateURL(params ={}){

        var timeZoneName = 'America/Denver'
        if (params.type == 'DailyKPIReport'){
            var queryParams ={
                date: this.state.date.format('MM-DD-YYYY-HH-mm'),
            }
        } else {
            var queryParams = {
                from: this.state.from.format('MM-DD-YYYY-HH-mm'),
                to: this.state.to.format('MM-DD-YYYY-HH-mm'),
                SellerID:this.state.filterOptions.SellerID !== 'all' ? this.state.filterOptions.SellerID : undefined,
                Markets: _.size(this.state.Markets) ? _.map(this.state.Markets, 'value') : undefined,
                reportFields: _.size(this.state.reportFields) > 0 && _.size(this.state.reportFields) < 5 ? _.map(this.state.reportFields, 'value') : undefined,
            }
        }
        var stringified = queryString.stringify(queryParams)


        this.context.router.push('/admin/reports?tab=kpi&' + stringified);
        if (params.type == 'DailyKPIReport'){
            return  {}
        }else {
            return {
                from: momentTimeZone.tz(this.state.from.format('MM-DD-YYYY HH:mm'), 'MM-DD-YYYY HH:mm', timeZoneName).toISOString(),
                to: momentTimeZone.tz(this.state.to.format('MM-DD-YYYY HH:mm'), 'MM-DD-YYYY HH:mm', timeZoneName).toISOString(),
            }
        }
    }

    render() {
       const displayCustomFilters = this.state.reportFields.find(item=>item.value == 'ProductItemsCreated')
         return (
             <div className="transaction-action-block top20">
                 <Row>
                     <Col md={2} xs={6}   className="top10">
                         <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                   onChange={(value) => {

                                       this.setState({from: value})
                                   }}
                                   value={this.state.from}
                                   inputProps={{placeholder: 'From'}}/>
                     </Col>
                     <Col md={2} xs={6}   className="top10">
                         <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                   onChange={(value) => {
                                       this.setState({to: value})
                                   }}
                                   value={this.state.to}
                                   inputProps={{placeholder: 'To'}}/>
                     </Col>
                     <Col xs={6}  sm={4} md={2}  className="top10">
                          <Select
                             tabIndex="0"
                             multi
                             clearable={false}
                             placeholder="Location"
                             options={   _.map(config.warehouseData, item => {
                                 return {value: item.MarketName, label: item.MarketName}
                             })}
                             onChange={(options)=>{
                                 this.setState({'Markets': options}, function () {

                                 });
                             }}
                             value={this.state.Markets}
                         />
                     </Col>
                     <Col md={6} sm={8} xs={12}   className="top10 ">
                         <Button style={{width: '180px'}}
                                 disabled={this.state.pending || _.size(this.state.KPIReportData) ==0}
                                 onClick={(e) =>{
                                     if (!validateEmail(this.state.emailAddress)) {
                                         return this.props.displayMessage({
                                             'messageType': 'warning',
                                             'messageCode': 'Email is not valid'
                                         });
                                     }
                                     this.getReportData({type:'sendemail'})
                                 }}
                                 className="pull-right btn btn-primary pull-right" type="button">
                             Send KPI report to email
                         </Button>
                         <FormControl type="email" style={{width: '200px'}} className="right15 pull-right"
                                      value={this.state.emailAddress}
                                      onChange={e => {
                                          this.setState({emailAddress: e.target.value})
                                      }}/>

                     </Col>
                 </Row>
                 {displayCustomFilters &&
                   <Row className=" top15 bot15">
                       <Col xs={8} md={3} sm={3}>
                           <ControlLabel>Seller for Product Items Created</ControlLabel>
                           <Select
                             tabIndex="0"
                             placeholder="Seller"
                             clearable={true}
                             options={this.allSellersOptionsList}
                             onChange={(option) => {
                                 const updateOptions = {
                                     ...this.state.filterOptions,
                                     SellerID: option ? option.value : null
                                 };
                                 this.setState({'filterOptions': updateOptions}, function () {

                                 });
                             }}
                             value={this.state.filterOptions.SellerID}
                           />
                       </Col>
                   </Row>
                 }
                 <Row >

                     <Col md={8} xs={12} className="top10">
                         <Select
                             tabIndex="0"
                             searchable={true}
                             multi
                             selectedOptions
                             clearable={false}
                             placeholder="Included fields"
                             options={_.orderBy(allReportFieldList, function (item) {
                                 return item.value
                             },[  'asc'])}
                             onChange={ (selectedOptions) => {
                                 if(selectedOptions.length > this.state.reportFields.length ) {
                                     const lastOption = _.last(selectedOptions)
                                     if (lastOption.value == 'ProductItemsCreated') {
                                         this.fetchAllSellerList()
                                     }
                                 }
                                 this.setState({'reportFields': selectedOptions})
                             }}
                             //  filterOptions={filterOptions}
                             value={this.state.reportFields}
                         />
                     </Col>

                 </Row>
                 <Row>




                     <Col   md={8} xs={12} className="top25">
                         <button className="btn btn-primary" disabled={this.state.pending}
                                 onClick={() => this.getReportData({type: 'download'})}
                                 type="button">
                             Download report
                         </button>
                         <button className="btn btn-primary pull-right" disabled={this.state.pending}
                                 onClick={ this.getReportData.bind(this)}
                                 type="button">
                             Display Data
                         </button>
                     </Col>
                     <Col md={2} xs={6}   className="top25">
                         <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                   isValidDate={  (date) => {

                                       if (moment(date).isAfter(moment().subtract(1, 'day'), 'day')) {
                                           return false;
                                       }
                                       return true
                                   }}
                                   onChange={(value) => {
                                       this.setState({date: value},  ()=>{
                                           if (this.state.date &&  moment(this.state.date, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
                                               this.getDailyKPIReportData( )
                                           }
                                       })
                                   }}
                                   value={this.state.date}
                                   inputProps={{placeholder: 'Daily KPI date'}}/>
                     </Col>
                 </Row>
                 {_.size(this.state.KPIReportData) >0 &&
                 <KPIReportsTable KPIReportData={this.state.KPIReportData} 
                     {...this.props} ></KPIReportsTable>
                 }
                 {_.size(this.state.DailyKPIReportData) >0 &&
                 <DailyKPIReportTable data={this.state.DailyKPIReportData}
                                  {...this.props} ></DailyKPIReportTable>
                 }
             </div>


        );
    }
}


function mapStateToProps(state) {
    return {
        allSellersList :state.allSellersList
    };

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, displayMessage, dispatchAction}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(KPIReportsPage);